import React, { Component } from 'react';
import ClassNames from 'classnames';

export default class Section extends Component {
    render() {
        const { rfqSection, rfqType } = this.props;
        
        return (
            <section className={ClassNames("flex ml-4", {
                'flex-column mt-25': rfqType != 9,
                'flex-between col-1 mt-5 pl-20': rfqType == 9
            })}>
                {rfqType != 9 && <span className="section-sub-header-color fBold fs-16">
                    {rfqSection.title}
                </span>}
                {
                    (rfqSection.fields || []).map((field, index) => {
                        return  Object.keys(field).length > 0 ? <div className={ClassNames("pv-20", {
                            'flex border-bottom-light': rfqType != 9
                        })} key={index}>
                        <div className="wt-150">
                            <span className="section-sub-header-colo fs-14">
                                {field.label}
                            </span>
                        </div>
                        <div className={(field && field.classname) ? field.classname : ""}>
                            <span className="section-sub-header-color fBold fs-14 op-7">
                                { field.value }
                            </span>
                        </div>
                    </div> : ''
                    })
                }
            </section>
        )
    }
}